import { createFileRoute, redirect } from "@tanstack/react-router";

/** The shop became part of the offer (ADR 0035): old links and bookmarks land on the same product. */
// oxlint-disable-next-line rules/require-route-crumb -- redirects before it renders
export const Route = createFileRoute("/(private)/shop/$productId/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/offer/products/$productId", params, replace: true });
  },
});
